import React, { useEffect } from 'react';
import copy from 'copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import { init, iconClick } from '../actions';
import ActionBox from './ActionBox';
import { CSSTransition } from 'react-transition-group';
import * as selectors from '../selectors';

export default ({ artId, link }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(init());
  }, []);
  const listsLoaded = useSelector(selectors.lists);
  const boxVisible = useSelector(selectors.boxVisible)(artId);
  const hasRemove = useSelector(selectors.hasRemove)(artId);
  if (!listsLoaded) {
    return null;
  }
  return (
    <CSSTransition appear in timeout={200} classNames="def-fade">
      <div className="fav__icons">
        <img
          className="fav__icon fav__icon--link"
          src="/wp-content/themes/taiderakentamisessa/dist/images/link.png"
          onClick={e => {
            e.preventDefault();
            copy(link);
            dispatch(iconClick({ artId, content: 'copied' }));
          }}
        />
        <img
          className="fav__icon fav__icon--plus"
          src="/wp-content/themes/taiderakentamisessa/dist/images/plus.png"
          onClick={e => {
            e.preventDefault();
            dispatch(iconClick({ artId, content: 'add' }));
          }}
        />
        {hasRemove && (
          <img
            className="fav__icon fav__icon--minus"
            src="/wp-content/themes/taiderakentamisessa/dist/images/minus.png"
            onClick={e => {
              e.preventDefault();
              dispatch(iconClick({ artId, content: 'remove' }));
            }}
          />
        )}
        <CSSTransition
          in={boxVisible}
          timeout={200}
          classNames="box-fade"
          mountOnEnter
          unmountOnExit
        >
          <ActionBox artId={artId} />
        </CSSTransition>
      </div>
    </CSSTransition>
  );
};
